import React, { useEffect, useState, useCallback } from 'react';
import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import config from '../config';

const ReceivedNotifications = () => {
    const { auth } = useAuth();
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchNotifications = useCallback(async () => {
        try {
            const response = await auth.fetch(`${config.API_BASE_URL}/api/notifications`);
            if (response.ok) {
                const data = await response.json();
                setNotifications(data.notifications || []);
            }
        } catch (error) {
            console.error('Error fetching notifications:', error);
        } finally {
            setLoading(false);
        }
    }, [auth]);

    useEffect(() => {
        fetchNotifications();
    }, [fetchNotifications]);

    const getLinkFromData = (dataJson) => {
        try {
            if (!dataJson) return null;
            const data = typeof dataJson === 'string' ? JSON.parse(dataJson) : dataJson;
            
            if (data.type === 'reverification_alert' && data.venue_id) {
                return `/venue-verification`; 
            }
        } catch (e) {
            return null;
        }
        return null;
    };

    if (loading) return (
        <div className="card h-100 p-0 radius-12 mt-24">
            <div className="card-body p-24 text-center">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        </div>
    );

    return (
        <div className="card h-100 p-0 radius-12 mt-24">
            <div className="card-header border-bottom bg-base py-16 px-24 d-flex justify-content-between align-items-center">
                <h6 className="text-lg fw-semibold mb-0">Received Notifications</h6>
                <button 
                    onClick={fetchNotifications} 
                    className="btn btn-sm btn-outline-secondary d-flex align-items-center gap-1"
                >
                    <Icon icon="mdi:refresh" /> Refresh
                </button>
            </div>
            <div className="card-body p-24">
                {notifications.length === 0 ? (
                    <div className="text-center text-secondary-light py-4">
                        <Icon icon="mdi:bell-off-outline" className="text-4xl mb-2 opacity-50" />
                        <p className="mb-0">No notifications found</p>
                    </div>
                ) : (
                    <div className="d-flex flex-column gap-3">
                        {notifications.map(notif => {
                            const link = notif.data ? getLinkFromData(notif.data) : null;
                            return (
                                <div key={notif.id} className={`alert ${notif.is_read ? 'bg-neutral-50 border-neutral-200' : 'bg-primary-50 border-primary-100'} d-flex align-items-start justify-content-between gap-3 mb-0 radius-8`}>
                                    <div className="d-flex gap-3">
                                        <div className={`w-40-px h-40-px rounded-circle d-flex justify-content-center align-items-center flex-shrink-0 ${notif.is_read ? 'bg-neutral-200 text-secondary-light' : 'bg-primary-100 text-primary-600'}`}>
                                            <Icon icon={notif.is_read ? "mdi:bell-outline" : "mdi:bell-ring-outline"} className="text-xl" />
                                        </div>
                                        <div>
                                            <h6 className="text-md fw-semibold mb-1">{notif.title}</h6>
                                            <p className="text-secondary-light text-sm mb-0">{notif.body}</p>
                                            <span className="text-xs text-secondary-light mt-4 d-block">
                                                {new Date(notif.created_at).toLocaleString()}
                                            </span>
                                        </div>
                                    </div>
                                    {link && (
                                        <Link to={link} className="btn btn-sm btn-primary-600 text-nowrap px-12">
                                            Review Venue
                                        </Link>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ReceivedNotifications;
